
<div class="main">
    <div class="loader" *ngIf="showLoader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="section">
      <div class="sectionHeader">
        <div class="header">
          <div class="title">
              <div class="label">
                  {{'ATTENDANCE_LIST.title' | translate}}
              </div>
              <div class="help">
                <!-- <app-help [helpData]="helpData" ></app-help> -->
              </div>
              <div class="refresh"  (click)="refreshDashboard()"><i class="material-icons" >refresh</i></div>
              <div class="addDriver mat-elevation-z4" routerLink="/drivers">
                <span class="text">{{'HEADER.myDrivers' | translate}}</span>
              </div>
            </div>
        </div>
      </div>
      <div class="filter">
        <div class="container">
        <div class="search">
            <div class="inputSearch">
                <input type="text"  (keyup)="searchFilter(filters.driver, 'driver')" [(ngModel)]="filters.driver"  [placeholder]="'ATTENDANCE_LIST.driver_name' | translate"  class="inputSelect">
                <!-- <i class="material-icons clearIcon" *ngIf="filters.name" (click)="filters.name = ''; clearFilter('name');"> clear </i> -->
            </div>
        </div>
        <div class="search">
          <div class="select-date">
            <div>
              <div class="inputSearch">
                <div class="inputSelect">
                  <mat-select [placeholder]="'ATTENDANCE_LIST.month' | translate" [(ngModel)]="filters.month">
                    <mat-option *ngFor="let month of months" (click)="$event.stopPropagation();selectMonth(month, $event)" [value]="month.name">
                      {{month.name}}
                    </mat-option>
                  </mat-select>
                </div>
                </div>
                <!-- <input type="text" class="dateSelect" [matDatepicker]="from_date"  [(ngModel)]="date_filter.from_date" [max]="date_filter.to_date" (click)="from_date.open()"/>
                <mat-datepicker #from_date (closed)="setFromDateTime(date_filter)" [startAt]="date_filter.from_date"></mat-datepicker>
                <i class="material-icons calendar">date_range</i> -->
            </div>
        </div>
        </div>
        <div class="search">
          <div class="select-date">
            <div>
              <div class="inputSearch">
                <div class="inputSelect">
                  <mat-select placeholder="Year" [(ngModel)]="filters.year">
                    <mat-option *ngFor="let year of years"  (click)="$event.stopPropagation();selectYear(year)" [value]="year">
                      {{year}}
                    </mat-option>
                  </mat-select>
                </div>
                </div>
            </div>
          </div>
        </div>
     </div>
    </div>
    <div class="accordion">
      <table mat-table class="mat-elevation-z8" *ngIf="attendnanceList && attendnanceList.filteredData.length;else noTrips" [dataSource]="attendnanceList.filteredData" matSort (matSortChange)="sortTripSheets($event)">
        <!--
  expenseList && expenseList.filteredData.length
        -->
        <ng-container matColumnDef="slno">
          <th mat-header-cell *matHeaderCellDef  class="customHeader">
            <span>
              {{ "ATTENDANCE_LIST.slno" | translate }}
            </span>
          </th>
          <td mat-cell *matCellDef="let element" class="customRow">
            {{element.index}}
          </td>
        </ng-container>
        <ng-container matColumnDef="driver">
          <th mat-header-cell *matHeaderCellDef  class="customHeader">
            <span>
              {{ "ATTENDANCE_LIST.driver_mobile" | translate }}
            </span>
          </th>
          <td mat-cell *matCellDef="let element" class="customRow">
            <div>{{element.driver_name}}</div>
            <div>{{element.driver_mobile}}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef class="customHeader">
            <span>
              {{ "ATTENDANCE_LIST.driver_type" | translate }}
            </span>
          </th>
          <td mat-cell *matCellDef="let element" class="customRow">
            <div>{{element.driver_type}}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="present">
          <th mat-header-cell *matHeaderCellDef class="customHeader">
            <span>
              {{ "ATTENDANCE_LIST.no_of_days_present" | translate }}
            </span>
          </th>
          <td mat-cell *matCellDef="let element" class="customRow">
            <div>{{element.present}}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="absent">
          <th mat-header-cell *matHeaderCellDef class="customHeader">
            <span>
              {{ "ATTENDANCE_LIST.no_of_days_absent" | translate }}
            </span>
          </th>
          <td mat-cell *matCellDef="let element" class="customRow">
            <div>{{element.absent}}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="customHeader">
            <span>
              <span class="material-icons">
                more_horiz
                </span>
            </span>
          </th>
          <td mat-cell *matCellDef="let element" class="customRow">
            <div class="buttons">
              <div class="button">
                  <mat-select [placeholder]="'ATTENDANCE_LIST.actions' | translate">
                    <mat-option (click)="openView(element);">  {{'ATTENDANCE_LIST.view' | translate}}</mat-option>
                    <!-- <mat-option (click)="$event.stopPropagation();openSalaryDetails(element);"> {{'ATTENDANCE_LIST.salary_details' | translate}}</mat-option> -->
                </mat-select>
              </div>
            </div>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
        </table>
        <mat-paginator fixed [length]="attendnanceList ? totalCount : 0" [pageSize]="25" [pageSizeOptions]="[5, 10, 25, 50, 100]" showFirstLastButtons (page)="pageNavigate($event)"></mat-paginator>
        <ng-template #noTrips>
          <div class="noOrders">
            {{ "ATTENDANCE_LIST.no_details" | translate }}
          </div>
        </ng-template>
  
    </div>
    </div>
  </div>
  
  